import React from 'react'
import { Link } from "react-router-dom";
import "../../styles/menu.css"
import Buscador from './buscador/Buscador'
import ContadorVisitas from "../Reutilizables/ContadorVisitas"

function Menu() {

  return (

    <div className="navbar">
      
       <div>
          <Link to="/" className='nav-link'>Inicio</Link>
        </div>

        <div className="subnav">
          <button className="subnavbtn-menu-inicio">Quiénes somos <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content-menu-inicio">
            <Link to="/nuestra-firma" className='nav-link'>Nuestra firma</Link>
            <Link to="/mision-y-vision" className='nav-link'>Misión y Visión</Link>
          </div>
        </div> 

        <Link to="/nuestros-clientes" className='nav-link'>Nuestros clientes</Link>

        <div>
          <Link to="/servicios" className='nav-link'>Servicios</Link>
        </div>

        <Link to="/contacto" className='nav-link'>Contáctenos</Link>

        <Link to="/registrarse" className='nav-link'> Suscribirse </Link>

        <Link to="/login-simple" className='nav-link'>Inicia sesión</Link>

        <div className='menu-prin-visitas'>
          <ContadorVisitas />
        </div>

        <div className='search'>
          <Buscador/>
        </div>

    </div>
  )
}

export default Menu